import { api } from './client';
import type { Gender } from "@/lib/types/auth";
import type { Audience } from "@/lib/types/audience";

export interface UpdateUserRequest {
  nickname?: string;
  gender?: Gender | null;
  audience?: Audience;
}

export interface UserProfile {
  id: number;
  nickname: string;
  gender: Gender | null;
  audience: string | null;
}

export const userApi = {
  getProfile: async (): Promise<UserProfile> => {
    const response = await api.get('/user/profile');
    return response;
  },

  updateProfile: async (data: UpdateUserRequest): Promise<UserProfile> => {
    const response = await api.patch('/user/profile', data);
    return response;
  },

  deleteAccount: async (): Promise<void> => {
    await api.delete('/user/account');
  },
};
